function DashboardService($q, AppSettings, AuthService, CommonService) {
  'ngInject';

  const service = {};

  // 대시보드 목록
  service.list = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'dashboard/list';
    return CommonService.post(url, params);
  };

  service.set = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'dashboard/set';
    return CommonService.post(url, params);
  };

  service.remove = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'dashboard/remove';
    return CommonService.post(url, params);
  };

  return service;
}

export default {
  name: 'DashboardService',
  fn: DashboardService
};
